import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Clock } from "@phosphor-icons/react";

export default function Expiring() {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    api.get("/documents/expiring", { params: { days: 90 } }).then((r) => setDocs(r.data));
  }, []);

  const now = new Date();

  return (
    <div className="space-y-6" data-testid="expiring-page">
      <div>
        <div className="label-caps">Certificates</div>
        <h2 className="font-display text-3xl text-navy uppercase mt-1">Expiring & expired</h2>
        <p className="text-sm text-zinc-500 mt-1">Documents expiring within 90 days, plus anything already expired.</p>
      </div>

      <div className="card-flat overflow-hidden">
        {docs.length === 0 ? (
          <div className="p-12 text-center text-zinc-500">All certificates are current.</div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b border-zinc-200 bg-zinc-50">
                <th className="px-4 py-3 label-caps">Document</th>
                <th className="px-4 py-3 label-caps">Expiry</th>
                <th className="px-4 py-3 label-caps">Days</th>
                <th className="px-4 py-3 label-caps">Status</th>
              </tr>
            </thead>
            <tbody>
              {docs.map((d) => {
                const exp = new Date(d.expiry_date);
                const days = Math.round((exp - now) / (1000 * 60 * 60 * 24));
                const expired = days < 0;
                return (
                  <tr key={d.id} className="dms-row border-b border-zinc-100" data-testid={`expiring-row-${d.id}`}>
                    <td className={`px-4 py-3 border-l-4 ${expired ? "border-red-500" : "border-orange-500"}`}>
                      <Link to={`/documents/${d.id}`} className="font-semibold text-navy hover:text-cyan transition-colors">
                        {d.title}
                      </Link>
                    </td>
                    <td className="px-4 py-3 font-mono text-zinc-700">{exp.toLocaleDateString()}</td>
                    <td className="px-4 py-3 font-mono">
                      <span className={expired ? "text-red-600" : "text-orange-600"}>
                        {expired ? `${Math.abs(days)}d ago` : `${days}d`}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 border rounded-sm ${expired ? "text-red-700 bg-red-50 border-red-200" : "text-orange-700 bg-orange-50 border-orange-200"}`}>
                        <Clock size={10} /> {expired ? "Expired" : "Expiring"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
